export function formatDate(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function formatShortDate(dateStr: string): { month: string; day: string } {
  const date = new Date(dateStr + 'T00:00:00')
  return {
    month: date.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
    day: String(date.getDate()),
  }
}

export function formatPrice(price: string | null): string {
  if (!price) return 'Price TBD'
  const num = parseFloat(price)
  if (num === 0) return 'Free'
  return `From $${num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
}

export function formatTime(timeStr: string | null): string | null {
  if (!timeStr) return null
  const date = new Date(timeStr)
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC',
  })
}

export function formatDressCode(code: string | null): string | null {
  if (!code) return null
  return code.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

const TIER_LABELS: Record<string, string> = {
  title: 'Title',
  presenting: 'Presenting',
  gold: 'Gold',
  silver: 'Silver',
  bronze: 'Bronze',
  in_kind: 'In-Kind',
  regular: '',
}

export function formatTier(tier: string): string {
  if (!tier) return ''
  return TIER_LABELS[tier] ?? tier.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function formatDollars(cents: number): string {
  const dollars = cents / 100
  if (cents % 100 === 0) {
    return `$${dollars.toLocaleString('en-US')}`
  }
  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// Stripe domestic-card pricing: 2.9% + $0.30. True gross-up so the org nets
// the listed price. Must match CheckoutController#gross_up_fee byte-for-byte.
const STRIPE_FEE_PERCENT = 0.029
const STRIPE_FEE_FIXED_CENTS = 30

export function grossUpStripeFee(baseCents: number): { feeCents: number; grossCents: number } {
  if (baseCents <= 0) return { feeCents: 0, grossCents: baseCents }
  const grossCents = Math.ceil((baseCents + STRIPE_FEE_FIXED_CENTS) / (1 - STRIPE_FEE_PERCENT))
  return { feeCents: grossCents - baseCents, grossCents }
}
